import { ErrorEvent } from '@sentry/angular';

export function errorFilter(event: ErrorEvent) {
  if (event.message && /Loading chunk \d+ failed/.test(event.message)) {
    window.location.reload();
  }

  event.tags = {
    ...event.tags,
    is_pwa:
      typeof window !== 'undefined' &&
      window.matchMedia('(display-mode: standalone)')?.matches,
  };

  return event;
}
